/**
 * tolling-api v2
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ActivityChargeResponseDto {
    type?: ActivityChargeResponseDto.TypeEnum;
    name?: string;
    amount?: number;
}
export namespace ActivityChargeResponseDto {
    export const TypeEnum = {
        TollCharge: 'TOLL_CHARGE',
        BaseFare: 'BASE_FARE',
        DistanceCharge: 'DISTANCE_CHARGE',
    } as const;
    export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];
}
